import React from 'react';
import { Button } from 'ra-ui-materialui';
import {
  Lock as LockIcon,
  LockOpen as UnlockIcon,
} from '@material-ui/icons';
import '../../styles.css';

export default ({
  dataProvider,
  resource,
  data,
  setSubmitting,
}) => {
  const handleClick = async () => {
    const status = data.status === 'inactive' ? 'active' : 'inactive';
    setSubmitting(true);
    dataProvider('CHANGESTATUS_ONE', resource, { id: data.id, status }, {
      onSuccess: {
        notification: { body: 'User Status Changed Successfully!', level: 'info' },
        callback: () => setSubmitting(false),
        refresh: true,
      },
      onError: {
        notification: { body: 'User Status Could Not Be Changed!', level: 'warning' },
        callback: () => setSubmitting(false),
      },
    });
  };
  return (
    <Button
      variant="contained"
      label={data.status === 'inactive' ? 'Unlock User' : 'Lock User'}
      style={{ width: '100%', marginTop: 4 }}
      className={data.status === 'inactive' ? 'successButton userActionButton' : 'errorButton userActionButton'}
      onClick={handleClick}
    >
      {data.status === 'inactive' ? (<UnlockIcon />) : (<LockIcon />)}
    </Button>
  );
};



// WEBPACK FOOTER //
// ./src/components/User/actions/actions/LockUnlockUserButton.jsx